"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsActions = void 0;
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
/**
 * This class manages all the public pubsub actions that can be performed
 * against the websocket service
 */
class WsActions {
    constructor(client) {
        this.client = client;
        this.reactionsByShowId = {};
        /**
         * Publishes the latest batch of show reaction message. This is throttled to
         * prevent unneeded chatter.
         */
        this.publishReactionMessage = lodash_throttle_1.default((showId) => {
            const message = {
                type: "publish/showreaction",
                id: showId,
                reactionCounts: this.reactionsByShowId[showId],
            };
            this.client.bufferMessages([message]);
            this.reactionsByShowId[showId] = [0, 0, 0];
        }, 200, { leading: true });
        /**
         * Typed subscriber to show reactions
         */
        this.subscribeShowReaction = this.client.makeSubscriber("showReaction");
        /**
         * Typed subscriber to show state changes
         */
        this.subscribeShowStateChange = this.client.makeSubscriber("show");
        /**
         * Typed subscriber to web client version changes
         */
        this.subscribeNewWebClientVersion = this.client.makeSubscriber("webClient", true);
        /**
         * Generic subscriber for any entity that gets published via websockets. If a
         * type param P is passed, it will be used to type the payload passed to the
         * callback.
         *
         * @param group The entity/collection type
         * @param key Entity id
         * @param cb The callback that will be executed with the websocket payload
         * @returns
         */
        this.subscribeEntity = (group, key, cb) => {
            return this.client.subscribe({
                group,
                key,
            }, cb);
        };
        /**
         * Generic subscriber for any entity that supports subscribing to a query
         * instead of a single id. If a type param P is passed, it will be used to
         * type the payload passed to the callback.
         *
         * @param group The entity/collection type
         * @param field Field to query buy
         * @param value Value for the given field
         * @param cb The callback that will be executed with the websocket payload
         * @returns
         */
        this.subscribeQuery = (entityType, field, value, cb) => {
            return this.client.subscribe({
                group: entityType,
                key: `${field}=${value}`,
            }, cb);
        };
    }
    /**
     * Queue a single reaction for a show and call the actual publish method
     *
     * @param showId id of show for which reactions are being published
     * @param idx index of reaction from reactions array
     */
    publishShowReaction(showId, idx) {
        this.reactionsByShowId[showId] = this.reactionsByShowId[showId] || [0, 0, 0];
        this.reactionsByShowId[showId][idx] += 1;
        this.publishReactionMessage(showId);
    }
}
exports.WsActions = WsActions;
